// src/dataProvider/clubScope.ts
export function pickClubId(params: any, globalClubId: number | null): number | null {
  const fromData =
    params?.data?.club_id ??
    params?.data?.clubId ??
    null;

  const fromFilter =
    params?.filter?.club_id ??
    params?.filter?.clubId ??
    null;

  return (fromData ?? fromFilter ?? globalClubId) ?? null;
}

export function withGlobalClubFilter(params: any, clubId: number | null) {
  if (!clubId) return params;
  return {
    ...params,
    filter: {
      ...(params?.filter ?? {}),
      clubId,
    },
  };
}

export function buildListQuery(params: any, mapKeys: Record<string, string> = {}) {
  const qs = new URLSearchParams();

  const { page, perPage } = params.pagination ?? { page: 1, perPage: 25 };
  const { field, order } = params.sort ?? { field: "id", order: "ASC" };

  qs.set("page", String(page));
  qs.set("perPage", String(perPage));
  qs.set("sort", mapKeys[field] ?? field);
  qs.set("order", order);

  Object.entries(params.filter ?? {}).forEach(([k, v]) => {
    if (v != null && v !== "") {
      qs.set(mapKeys[k] ?? k, String(v));
    }
  });

  return qs;
}
